import React, { useState } from "react"
import { useBlocks } from "../../hooks/use-blocks"
import { useEditing } from "../../hooks/use-editing"
import { Image, ASPECT_RATIOS } from "./image"
import { OldButton } from "@kit/design/old-button"
import { FileGallery } from "core/file-gallery"
import { appFont } from "../setting-utils"
import { Block } from "../shared/block"

function useFileGallery(id) {
  const [active, setActive] = useState(false)
  const { add } = useBlocks(id)
  const open = () => setActive(true)

  const close = file => {
    if (file?.dataURL) {
      add({
        type: "image",
        parent_id: id,
        properties: {
          alt: file.alt,
          src: file.dataURL
        }
      })
    }
    setActive(false)
  }

  return { active, open, close }
}

function GridUploader({ addImage, borderRadius, columns, crop }) {
  const buttonStyles = {
    borderRadius: borderRadius,
    position: crop === "none" ? "relative" : "absolute",
    inset: 0,
    borderWidth: 2,
    width: "100%"
  }

  return (
    <div
      style={{
        position: "relative",
        width: columns == 1 ? "100%" : "calc(50% - 5px)"
      }}
      id="addImage"
    >
      <OldButton
        is="secondary"
        className="w-full h-full text-gray-500 border-dashed"
        style={{ ...buttonStyles, fontFamily: appFont }}
        onClick={addImage}
        icon="plus-circle"
      >
        Add image
      </OldButton>
      <div
        className="pointer-events-none"
        style={{
          paddingBottom: ASPECT_RATIOS[crop]
        }}
      />
    </div>
  )
}

export function Gallery({ id }) {
  const editing = useEditing()
  const fileGallery = useFileGallery(id)
  const { children, properties } = useBlocks(id)

  return (
    <Block
      id={id}
      style={{
        display: "flex",
        padding: 0,
        margin: "16px 0",
        flexWrap: "wrap",
        gap: 10
      }}
    >
      {children.map(image => (
        <div
          key={image.block_id}
          style={{
            width: properties.columns === 1 ? "100%" : "calc(50% - 5px)",
            position: "relative"
          }}
        >
          <Image
            data={image}
            block_id={image.block_id}
            properties={properties}
          />
        </div>
      ))}
      {editing && (
        <>
          <GridUploader
            addImage={fileGallery.open}
            borderRadius={properties.radius}
            columns={properties.columns}
            crop={properties.crop}
          />
          <FileGallery
            active={fileGallery.active}
            onClose={fileGallery.close}
            allowedFileTypes={["image"]}
          />
        </>
      )}
    </Block>
  )
}
